module.exports = __webpack_public_path__ + "static/media/folderHidden.049d1c4f.svg";